import type {IndexCopilotSpace} from '@github-ui/copilot-chat-types'
import {COPILOT_SPACES_QUERY_KEY, fetchCopilotSpaces} from '@github-ui/copilot-shared-ui/spaces/fetch'
import {useQuery, type UseQueryResult} from '@github-ui/react-query'

interface UseSpacesOptions {
  enabled?: boolean
  onError?: (error: unknown) => void
}

export function useSpaces({enabled = true, onError}: UseSpacesOptions = {}): UseQueryResult<
  IndexCopilotSpace[],
  Error
> {
  return useQuery<IndexCopilotSpace[], Error>({
    queryKey: COPILOT_SPACES_QUERY_KEY,
    queryFn: async () => {
      try {
        return await fetchCopilotSpaces()
      } catch (error) {
        onError?.(error)
        throw error
      }
    },
    staleTime: 5 * 60 * 1000,
    enabled,
  })
}
